<template>
	<aside v-if="ready" class="main">
		<div class="form">
			<div class="form-row">
				<fieldset>
					<input placeholder="First Name*"
						   type="text"
						   tabindex="1"
						   required
						   autofocus
						   :class="{'error': !validate.firstName}"
						   @focus="validate.firstName = true"
						   v-model="form.firstName">
				</fieldset>
				<fieldset>
					<input placeholder="Last Name*"
						   type="text"
						   tabindex="2"
						   required
						   :class="{'error': !validate.lastName}"
						   @focus="validate.lastName = true"
						   v-model="form.lastName">
				</fieldset>
			</div>
			<div class="form-row">
				<fieldset>
					<input placeholder="Email Address*"
						   type="email"
						   tabindex="3"
						   required
						   :class="{'error': !validate.emailAddress}"
						   @focus="validate.emailAddress = true"
						   v-model="form.emailAddress">
				</fieldset>
				<fieldset>
					<input placeholder="Phone Number*"
						   type="tel"
						   tabindex="4"
						   required
						   :class="{'error': !validate.phoneNumber}"
						   @focus="validate.phoneNumber = true"
						   v-model="form.phoneNumber">
				</fieldset>
			</div>
			<div class="form-row">
				<fieldset>
					<label><strong>Requested Date of Appointment</strong></label>
					<input min="2020-01-01"
						   type="date"
						   tabindex="3"
						   required
						   :class="{'error': !validate.requestedDate}"
						   @focus="validate.requestedDate = true"
						   v-model="form.requestedDate">
				</fieldset>
				<fieldset>
					<label><strong>Best Time For You</strong></label>
					<select tabindex="6"
							required
							:class="{'error': !validate.bestTime}"
							@focus="validate.bestTime = true"
							v-model="form.bestTime">
						<option value="" disabled selected>Select</option>
						<option v-for="item in bestTimeOptions" :value="item"> {{ item }}</option>
					</select>
				</fieldset>
			</div>
		</div>
		<div class="footer-actions">
			<button class="btn-beltone xl" @click="submit()" >Submit</button>
		</div>
		<!--		<p class="message success">Form Submitted Successfully!</p>-->
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Services from '../mixins/services';


export default {
	mixins: [Services],
	props: ['clinicUrl'],
	components: {
	},
	data: function () {
		return {
			ready: false,
			bestTimeOptions: [
				'Morning',
				'Afternoon',
				'Early Evening',
				'Anytime Is Fine For Me'
			],
			validate: {
				firstName: true,
				lastName: true,
				emailAddress: true,
				phoneNumber: true,
				requestedDate: true,
				bestTime: true
			},
			form: {
				firstName: '',
				lastName: '',
				emailAddress: '',
				phoneNumber: '',
				requestedDate: '',
				bestTime: '',
        clinicUrl: '',
        digitalLeadType: 'RequestAnAppointment'
			}
		}
	},
	computed: mapState({
		clientToken: state => state.ClientToken.clientToken,
	}),
	methods: {
		...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
		...mapActions('FormContactUs', { postSubmitForm: 'postSubmitForm' }),
		submit() {
			if (this.validation()) {
        let _data = this.form;
        if(sessionStorage.getItem("utm_source")) _data.UtmSource = sessionStorage.getItem("utm_source")
        if(sessionStorage.getItem("utm_medium")) _data.UtmMedium = sessionStorage.getItem("utm_medium")
        if(sessionStorage.getItem("utm_campaign")) _data.UtmCampaign = sessionStorage.getItem("utm_campaign")
        if(sessionStorage.getItem("utm_content")) _data.UtmContent = sessionStorage.getItem("utm_content")
        if(sessionStorage.getItem("referrer_url")) _data.ReferrerUrl = sessionStorage.getItem("referrer_url")
        this.postSubmitForm({
					data: _data,
					ClientToken: this.clientToken,
					cb: () => {
                        this.goToThankYouPage();
					}
				})
			}
		},
		validation() {
			let valid = true;
            let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
			let phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

			if (this.form.firstName.trim().length === 0) {
				this.validate.firstName = false;
				valid = false;
			}
			if (this.form.lastName.trim().length === 0) {
				this.validate.lastName = false;
				valid = false;
			}
			if (!emailRegex.test(this.form.emailAddress)) {
				this.validate.emailAddress = false;
				valid = false;
			}
			if (!phoneRegex.test(this.form.phoneNumber)) {
				this.validate.phoneNumber = false;
				valid = false;
			}
			if (this.form.requestedDate.trim().length === 0) {
				this.validate.requestedDate = false;
				valid = false;
			}
			if (this.form.bestTime.trim().length === 0) {
				this.validate.bestTime = false;
				valid = false;
			}
			return valid;
		},
        goToThankYouPage() {
            window.top.location.href = `${document.referrer}/thank-you/`;
        }
	},
	created() {
		// https://localhost:7224/formRequestAppointment?utm_source=Google&utm_medium=PPC&utm_campaign=nashvilletn&utm_content=HearingTest
		// const urlParams = new URLSearchParams(window.location.search);
		// if (urlParams.get('utm_source')) sessionStorage.setItem('utm_source', urlParams.get('utm_source'));
		// if (urlParams.get('utm_medium')) sessionStorage.setItem('utm_medium', urlParams.get('utm_medium'));
		// if (urlParams.get('utm_campaign')) sessionStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
		// if (urlParams.get('utm_content')) sessionStorage.setItem('utm_source', urlParams.get('utm_content'));

		this.getClientToken({
			cb: () => {
				this.form.clinicUrl = this.clinicUrl;
				this.ready = true;
				setInterval(() => {
					let height = $('body').outerHeight(); // IMPORTANT: If body's height is set to 100% with CSS this will not work.
					parent.postMessage("resize::formRequestAppointment" + height,"*");
				}, 1000);
			}
		});
	}
}
</script>
